import React from "react";
import { useTranslation } from "react-i18next";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export const ThemeToggle = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? t("theme.switch_to_light") : t("theme.switch_to_dark");

  return (
    <button
      onClick={toggleTheme}
      type="button"
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      data-tip={t("tips.theme", "Thème : passez du mode clair au mode sombre.")}
      className="font-mono uppercase tracking-[0.2em] text-[10px] px-2.5 py-1.5 border border-transparent hover:border-border text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5"
    >
      {isDark ? (
        <Sun className="w-3.5 h-3.5" />
      ) : (
        <Moon className="w-3.5 h-3.5" />
      )}
    </button>
  );
};
